module.exports = __webpack_public_path__ + "static/media/g-3-b.a70bbadb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-3-b.jpg
// module id = 1133
// module chunks = 33